module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmsdetail"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_vm._l((_vm.breadData), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": item.path
      }
    }, [_c('a', [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("详情")])], 2), _vm._v(" "), _c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "goods-info"
  }, [_c('div', {
    staticClass: "goods-info-left"
  }, [_c('el-carousel', {
    ref: "carousel",
    staticStyle: {
      "width": "320px",
      "overflow": "hidden"
    },
    attrs: {
      "indicator-position": "outside",
      "initial-index": _vm.swipe_index,
      "autoplay": _vm.row.videos_url ? false : true,
      "trigger": "click",
      "height": "320px;"
    },
    on: {
      "change": _vm.onSwipeChange
    }
  }, [(_vm.row.videos_url) ? _c('el-carousel-item', [_c('video', {
    staticStyle: {
      "width": "320px",
      "height": "320px"
    },
    attrs: {
      "src": _vm.row.videos_url,
      "controls": "controls"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.pics_url), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": "",
        "srcset": ""
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scorll-img-box"
  }, [(_vm.row.videos_url) ? _c('video', {
    class: _vm.swipe_index == 0 ? 'scorll-items-active' : 'scorll-items',
    staticStyle: {
      "min-wdith": "50px",
      "wdith": "50px",
      "height": "50px"
    },
    attrs: {
      "src": _vm.row.videos_url
    },
    on: {
      "click": function($event) {
        return _vm.onSwipeChickChange(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.pics_url), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.swipe_index == (_vm.row.videos_url ? index + 1 : index) ? 'scorll-items-active' : 'scorll-items',
      on: {
        "click": function($event) {
          return _vm.onSwipeChickChange(index + 1)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "min-wdith": "50px",
        "wdith": "50px",
        "height": "50px"
      },
      attrs: {
        "src": item,
        "alt": "",
        "srcset": ""
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-info-main"
  }, [_c('div', {
    staticClass: "text-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "acea-row row-middle money-wrapper"
  }, [_c('div', {
    staticClass: "money-wrap"
  }, [_c('del', [_vm._v("原价：￥" + _vm._s(_vm.row.orig_price))]), _vm._v(" "), _c('div', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v("  \n                  ￥"), _c('span', [(_vm.goods_price == 0) ? _c('b', {
    attrs: {
      "id": "products"
    }
  }, [_vm._v(_vm._s(_vm.row.price_range[0]))]) : _c('b', {
    attrs: {
      "id": "products"
    }
  }, [_vm._v(_vm._s(_vm.goods_price))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sales acea-row row-column row-center-wrapper"
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v("\n                " + _vm._s(_vm.row.sold_show_count + _vm.row.sold_count) + "\n              ")]), _vm._v(" "), _c('div', [_vm._v("销量")])])])]), _vm._v(" "), _c('div', {
    staticClass: "goods-info-main-box"
  }, [_c('form', {
    staticClass: "xqq-topm"
  }, [_c('div', {
    staticClass: "xqq-pmd"
  }, [_c('div', {
    staticClass: "xx-dq"
  }, _vm._l((_vm.sku.tree), function(tree, findex) {
    return _c('div', {
      key: findex
    }, [_c('div', {
      staticClass: "default"
    }, [_vm._v(_vm._s(tree.k))]), _vm._v(" "), _c('div', {
      staticClass: "attr-box"
    }, _vm._l((tree.v), function(attr, aindex) {
      return _c('div', {
        key: aindex,
        class: ['format-list-item', attr.checked ? 'active' : '', attr.disabled ? 'disabled' : ''],
        on: {
          "click": function($event) {
            return _vm.skuChoose(findex, aindex, attr)
          }
        }
      }, [_c('div', {
        staticClass: "pointer"
      }, [_vm._v(_vm._s(attr.name))])])
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "lj-gm"
  }, [_c('a', {
    staticClass: "lj-gml",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.toBuy(1)
      }
    }
  }, [_vm._v("立即购买")]), _vm._v(" "), _c('a', {
    staticClass: "lj-gmr add_cart_large btnCart",
    attrs: {
      "href": "javascript:;",
      "id": "addcarts"
    },
    on: {
      "click": function($event) {
        return _vm.toBuy(2)
      }
    }
  }, [_vm._v("加入购物车")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "main-right default"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("客服咨询")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.chat.pic_url,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.chat.wxcode) ? _c('p', [_vm._v("WeChat:" + _vm._s(_vm.chat.wxcode))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "service-btn pointer"
  }, [_vm._v("点击联系客服")]), _vm._v(" "), _c('p', {
    staticClass: "p2 default"
  }, [_vm._v("免费预约顾问，极速为您服务")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "请输入您的姓名"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "phone",
      "placeholder": "请输入您的电话号码"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "appointment-btn pointer",
    on: {
      "click": _vm.onAppointment
    }
  }, [_vm._v("免费预约")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-detail-box"
  }, [_c('div', {
    class: _vm.pos_status ? 'goods-detail-pos' : ''
  }, [_c('div', {
    staticClass: "goods-detail"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "two"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "one"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "goods-detail-row-list default"
  }, _vm._l((_vm.row.extra_data), function(item, i) {
    return _c('div', {
      key: i
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" :\n                  "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "html-data",
    staticStyle: {
      "padding": "10px 30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })])])], 1), _vm._v(" "), (_vm.order_visible) ? _c('div', {
    staticClass: "order-box"
  }, [(_vm.order_visible) ? _c('div', {
    staticClass: "order-center"
  }, [_c('p', {
    staticClass: "order-center-title flex-between"
  }, [_vm._v("\n        确认购买\n        "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px",
      "cursor": "pointer"
    },
    attrs: {
      "src": "https://www.meijiexia.cn/statics/new/201805/images/tk_close.png",
      "alt": ""
    },
    on: {
      "click": _vm.onClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-goods flex-between"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.pic_url,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-title"
  }, [_c('p', {
    staticClass: "show-two-row"
  }, [_vm._v(_vm._s(_vm.row.title))])]), _vm._v(" "), _c('div', {
    staticClass: "order-sku show-two-row"
  }, [_vm._v(_vm._s(_vm.goods_sku_names))]), _vm._v(" "), _c('div', {
    staticClass: "goods-price-count"
  }, [_c('p', {
    staticClass: "default"
  }, [_vm._v("单价:¥" + _vm._s(_vm.goods_price))]), _vm._v(" "), _c('p', {
    staticClass: "default"
  }, [_vm._v("数量 :" + _vm._s(_vm.goods_count))])]), _vm._v(" "), _c('div', {
    staticClass: "pay-price default"
  }, [_vm._v("\n          总计:\n          "), _c('span', {
    staticStyle: {
      "color": "#0175c0"
    }
  }, [_vm._v("¥" + _vm._s(_vm.goods_pay_price))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-count-add"
  }, [_c('span', {
    staticClass: "default"
  }, [_vm._v("购买数量 :")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 100,
      "label": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.goods_count),
      callback: function($$v) {
        _vm.goods_count = $$v
      },
      expression: "goods_count"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "all-pay_price"
  }, [_c('div', [_vm._v("\n          应付:\n          "), _c('span', {
    staticStyle: {
      "color": "#0175c0"
    }
  }, [_vm._v("¥" + _vm._s(_vm.goods_pay_price))])]), _vm._v(" "), (_vm.buyAddStatus == 1) ? _c('div', {
    staticClass: "order-add flex-center pointer",
    on: {
      "click": _vm.orderAdd
    }
  }, [_vm._v("提交订单")]) : _vm._e(), _vm._v(" "), (_vm.buyAddStatus == 2) ? _c('div', {
    staticClass: "order-add flex-center pointer",
    on: {
      "click": _vm.orderAddCart
    }
  }, [_vm._v("加入购物车")]) : _vm._e()])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default",
    staticStyle: {
      "padding": "20px",
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "detail-solid"
  }), _vm._v(" 商品详情\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67930682","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsDetail.vue
// module id = 1266
// module chunks = 0